import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Spinner, Alert } from 'react-bootstrap';
import { API_URL, UPLOADS_API_URL } from "../config"; 

const CompanyBranchCards = () => {
  const [companyDetails, setCompanyDetails] = useState(null);
  const [branchDetails, setBranchDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [companyError, setCompanyError] = useState(null);
  const [branchError, setBranchError] = useState(null);
  
  const companyId = localStorage.getItem("company_id");
  const branchId = localStorage.getItem("branch_id");

  useEffect(() => {
    const fetchCompanyAndBranchDetails = async () => {
      if (!companyId || !branchId) {
        console.error("Company ID or Branch ID is missing from local storage.");
        setLoading(false);
        return;
      }

      // Fetch Company Details
      try {
        const companyResponse = await fetch(`${API_URL}/companysetup/${companyId}`);
        if (!companyResponse.ok) {
          throw new Error("Failed to fetch company data");
        }
        const companyData = await companyResponse.json();
        setCompanyDetails(companyData);

      } catch (error) {
        setCompanyError("No company details found.");
        console.error("Error fetching company data:", error);
      }

      console.log("Kambani yancu", companyDetails);

      // Fetch Branch Details
      try {
        const branchResponse = await fetch(`${API_URL}/branch/${branchId}`);
        if (!branchResponse.ok) {
          throw new Error("Failed to fetch branch data");
        }
        const branchData = await branchResponse.json();
        console.log("Fetched Branch Details:", branchData); // Log branch details
        
        // Assuming branchData is an array and we want the first item
        if (branchData.length > 0) {
          setBranchDetails(branchData[0]); // Set the first branch object
        } else {
          setBranchError("No branch details found.");
        }

      } catch (error) {
        setBranchError("No branch details found.");
        console.error("Error fetching branch data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyAndBranchDetails();
  }, [companyId, branchId]);

  if (loading) {
    return <Spinner animation="border" />;
  }

  return (
    <Row className="justify-content-center" style={{ marginTop: "30px", marginBottom: "30px" }}>
      <Col md={4}>
        <Card className="shadow-sm border-warning">
          <Card.Body>
            {companyDetails && companyDetails.portrait_logo ? (
              <img 
                src={`${UPLOADS_API_URL}/${companyDetails.portrait_logo}`} 
                alt="Company Logo" 
                style={{ width: "30%", height: "auto" }} 
              />
            ) : (
              <Alert variant="danger">No logo available.</Alert>
            )}
          </Card.Body>
        </Card>
      </Col>
      <Col md={4}>
        <Card className="shadow-sm border-warning">
          <Card.Body>
            <h6 className="mb-2">Company</h6>
            {companyError ? (
              <Alert variant="danger">{companyError}</Alert>
            ) : (
              companyDetails && (
                <>
                  <p className="mb-0 text-primary" style={{fontWeight: 'bold'}}>{companyDetails.name}</p>
                  <p className="mb-0 text-primary" style={{fontWeight: 'bold'}}>{companyDetails.industry}</p>
                </>
              )
            )}
          </Card.Body>
        </Card>
      </Col>
      <Col md={4}>
        <Card className="shadow-sm border-warning">
          <Card.Body>
            <h6 className="mb-2">Branch</h6>
            {branchError ? (
              <Alert variant="danger">{branchError}</Alert>
            ) : (
              branchDetails && (
                <>
                  <p className="mb-0 text-primary" style={{fontWeight: 'bold'}}>{branchDetails.branch_name}</p>
                  <Row style={{textAlign: 'center', fontSize: '10px'}}>
                    <Row>
                      <p>{branchDetails.branch_location}</p>
                    </Row>
                    <Row>
                      <p >City: {branchDetails.branch_city}</p>
                    </Row>
                  </Row>
                </>
              )
            )}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default CompanyBranchCards;